module.exports = __webpack_public_path__ + "assets/404.ba528d13058fc17c6038e9b8fdea9ea818436b56ab8fb8af2af48aaa168f79e8.png";